import { ChevronUp, RotateCcw } from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setToogleHeader } from "../../core/redux/action";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Select, message } from "antd";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import {
  AllCommunityModule,
  ModuleRegistry,
  provideGlobalGridOptions,
} from "ag-grid-community";
import { getProductOrderDataByBrandId, getLastSalesDumpUploadDate } from "../../core/api/report";
import { fetchBrandsBySelectedClients } from "../../core/api/settings";
import UploadSalesDumpFile from "./uploadsalesdumpfile";
import {PlusCircle } from "feather-icons-react/build/IconComponents";
import { getCurrentUser } from "../../core/api/settings";
import { getProfile } from "../../core/api/auth.js";
import moment from "moment";

ModuleRegistry.registerModules([AllCommunityModule]);
provideGlobalGridOptions({ theme: "legacy" });

const SalesDump = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);

  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [brands, setBrands] = useState([]);
  const selectedClients = useSelector((state) => state.selectedClients);
  const [loadingBrands, setLoadingBrands] = useState(false);
  const [isUploadViewVisible, setIsUploadViewVisible] = useState(false);
  const [previewReportId, setPreviewReportId] = useState(null);
  const [user, setUser] = useState(null);
  const [userLoading, setUserLoading] = useState(true);
  const [lastUploadDate, setLastUploadDate] = useState(null);
  const [loadingLastUploadDate, setLoadingLastUploadDate] = useState(false);


  useEffect(() => {
    setBrands([]);
    setSelectedBrand(null);
    fetchBrandsBySelectedClients(selectedClients)
      .then((res) => {
        if (!res.data || res.data.length === 0) return;
        setBrands(res.data);
        if (res.data.length === 1) {
          const autoSelectedBrand = res.data[0].id;
          setSelectedBrand(autoSelectedBrand);
        }
        setLoadingBrands(false);
      })
      .catch(() => {
        setLoadingBrands(false);
        message.error("Failed to fetch brands.");
      });
  }, [selectedClients]);

  useEffect(() => {
    if (!selectedBrand) return;

    // Fetch product order data
    setLoading(true);
    getProductOrderDataByBrandId(selectedBrand)
      .then((res) => {
        setRowData(res.data);
      })
      .catch((err) => {
        console.error(err);
        message.error("Error fetching data");
      })
      .finally(() => {
        setLoading(false);
      });
      
    // Fetch the latest upload date for this brand
    setLoadingLastUploadDate(true);
    getLastSalesDumpUploadDate(selectedBrand)
      .then((res) => {
        if (res.data && res.data.last_upload_date) {
          setLastUploadDate(res.data.last_upload_date);
        } else {
          setLastUploadDate(null);
        }
      })
      .catch((err) => {
        console.error("Error fetching last upload date:", err);
        setLastUploadDate(null);
      })
      .finally(() => {
        setLoadingLastUploadDate(false);
      });
  }, [selectedBrand]);



  const columns = useMemo(() => {
    if (rowData.length === 0) return [];
    return Object.keys(rowData[0])
      .filter((key) => !["id", "brand", "file"].includes(key))
      .map((key) => ({
        headerName: key
          .replace(/_/g, " ")
          .replace(/\b\w/g, (char) => char.toUpperCase()),
        field: key,
        sortable: true,
        filter: true,
        resizable: true,
      }));
  }, [rowData]);

  const handleUploadFile = () => {
    if (selectedClients.length !== 1 || selectedClients[0] === "all") {
      message.warning("Please select exactly one client.");
      return;
    }
    setIsUploadViewVisible(true);
  };

 
   

  return (
    <div className="">
      <div className="">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>
                Sales Dump
              </h4>
            </div>
          </div>

          <ul className="table-top-head">
            <li>
            {lastUploadDate && selectedBrand && (
                  <span style={{ fontSize: '14px', fontWeight: 'normal', marginLeft: '15px', color: '#666' }}>
                    Last Uploaded on: {moment(lastUploadDate).format("DD/MM/YYYY")} 
                    {loadingLastUploadDate && <span style={{ marginLeft: '5px' }}>...</span>}
                  </span>
                )}
            </li>
            <li>
              <Select
                placeholder="Select Brand"
                options={brands.map((brand) => ({
                  value: brand.id,
                  label: brand.brand_name,
                }))}
                onChange={(values) => setSelectedBrand(values)}
                value={selectedBrand}
                loading={loadingBrands}
              />
            </li>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Print</Tooltip>}
              >
                <Link
                  onClick={() => {
                    // intentionally empty
                  }}
                >
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Excel</Tooltip>}
              >
                <Link
                  onClick={() => {
                    // intentionally empty
                  }}
                >
                  <ImageWithBasePath src="assets/img/icons/xls.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Refresh</Tooltip>}
              >
                <Link
                  onClick={() => getProductOrderDataByBrandId(selectedBrand)}
                >
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Collapse</Tooltip>}
              >
                <Link
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => dispatch(setToogleHeader(!data))}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          <div className="page-btn">
             
            <button className="btn btn-added" onClick={handleUploadFile}>
              <PlusCircle className="me-2 iconsize" />
              Upload Sales Dump File
            </button>
          </div>
        </div>

        {/* Ag-Grid Table */}
        <div className="card table-list-card">
          <div
            className="ag-theme-quartz"
            style={{ height: "700px", width: "100%" }}
          >
            <AgGridReact
              columnDefs={columns}
              rowData={rowData}
              defaultColDef={{ flex: 1, minWidth: 100 }}
              pagination={false}
              loading={loading}
            />
          </div>
        </div>
      </div>
      <UploadSalesDumpFile
        isVisible={isUploadViewVisible}
        onClose={() => {
          setIsUploadViewVisible(false);
          setPreviewReportId(null);
        }}
        onResize={() => {
          // intentionally empty
        }}
        clientId={selectedClients[0]}
        reportId={previewReportId}
      />
    </div>
  );
};

export default SalesDump;
